<template>
  <div class="h-100 w-100">
    <div class="d-flex my-25 justify-content-center">
      <b-button size="sm" variant="success" @click="$emit('download')"
        >تحميل</b-button
      >
    </div>
    <iframe
      class="rounded"
      style="width: 100%; height: 100%"
      :key="src"
      :src="src"
    >
    </iframe>
  </div>
</template>

<script>
import { BButton } from "bootstrap-vue";
export default {
  props: ["src"],
  components: {
    BButton,
  },
};
</script>
